// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2HCg3","actions":"GroupTable_actions__3BKj-","deleteModalFooter":"GroupTable_deleteModalFooter__1vP8Z"};